import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWand32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconWand32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.024 4.558a1 1 0 1 1 2 0 3.39 3.39 0 0 0 3.392 3.392 1 1 0 0 1 0 2 3.39 3.39 0 0 0-3.392 3.392 1 1 0 0 1-2 0 3.39 3.39 0 0 0-3.39-3.392h-.002a1 1 0 0 1 0-2h.002a3.39 3.39 0 0 0 3.39-3.392m1 3.129c.348.488.776.915 1.263 1.263a5.4 5.4 0 0 0-1.263 1.264A5.4 5.4 0 0 0 7.761 8.95a5.4 5.4 0 0 0 1.263-1.263m11.638.737 2.502-2.502 2.828 2.828-2.502 2.503zm-1.415 1.414L6.015 23.071 8.843 25.9l13.233-13.232zM4.601 24.485a2 2 0 0 1 0-2.828L21.75 4.507a2 2 0 0 1 2.828 0l2.829 2.83a2 2 0 0 1 0 2.828l-17.15 17.149a2 2 0 0 1-2.828 0zM25 16a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1m-5.975 6.718a1 1 0 0 1 1 1v.333h.333a1 1 0 1 1 0 2h-.333v.334a1 1 0 1 1-2 0v-.334h-.333a1 1 0 0 1 0-2h.333v-.333a1 1 0 0 1 1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWand32);
